import React, { useState, useEffect } from 'react';
import { Sun, Moon, Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'about',       href: '#about' },
  { label: 'skills',      href: '#skills' },
  { label: 'experience',  href: '#experience' },
  { label: 'projects',    href: '#projects' },
  { label: 'blog',        href: '#blog' },
  { label: 'contact',     href: '#contact' },
];

export default function Navbar({ theme, toggleTheme }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const close = () => setOpen(false);

  return (
    <>
      <header className={`navbar${scrolled ? ' scrolled' : ''}`}>
        <div className="nav-inner container">
          <a href="#hero" className="brand" onClick={close}>
            rb<span>.</span>dev
          </a>

          <nav className="nav-links" aria-label="Primary navigation">
            {NAV_LINKS.map(({ label, href }) => (
              <a key={label} href={href}>{label}</a>
            ))}
          </nav>

          <div className="nav-actions">
            <button
              className="theme-btn"
              onClick={toggleTheme}
              aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
              title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
            >
              {theme === 'dark' ? <Sun size={17} /> : <Moon size={17} />}
            </button>

            <button
              className={`hamburger${open ? ' open' : ''}`}
              onClick={() => setOpen(o => !o)}
              aria-label="Toggle menu"
              aria-expanded={open}
            >
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>
      </header>

      <nav className={`mobile-menu${open ? ' open' : ''}`} aria-label="Mobile navigation">
        {NAV_LINKS.map(({ label, href }) => (
          <a key={label} href={href} onClick={close}>{label}</a>
        ))}
      </nav>
    </>
  );
}
